import { useState } from 'react'
import { Button } from 'reactstrap'
import { Navigation, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/effect-fade'
import 'swiper/css/effect-flip'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import { Swiper, SwiperSlide } from 'swiper/react'
import Lightbox from 'yet-another-react-lightbox'
import Counter from 'yet-another-react-lightbox/plugins/counter'
import 'yet-another-react-lightbox/plugins/counter.css'
import 'yet-another-react-lightbox/styles.css'
import images from '../../api/images/hooks'
import AppPermissionsSwitcher from '../AppPermissionsSwitcher/AppPermissionsSwitcher'
import Loader from '../Common/Loader'
import { useBlobUrls } from '../Hooks/useBlobUrl'
import styles from './Slider.module.css'

const Slider = ({ imageList, module }) => {
    const [fullScreen, setFullScreen] = useState(false)
    const [indexPhoto, setIndexPhoto] = useState(0)
    const [swiperIndex, setSwiperIndex] = useState(null)

    const slideUrlQueries = images.GetImagesByUrl.useQueries(imageList, '')
    const blobUrls = useBlobUrls(slideUrlQueries)

    const slides = imageList.map((file, i) => ({
        id: file.id,
        fileSync: file.fileSync,
        thumb: blobUrls[i],
        isLoading: slideUrlQueries[i].isPending,
    }))

    const handleLightBoxOpen = (index) => {
        setFullScreen(true)
        setIndexPhoto(index)
    }

    const handleLightBoxClose = () => {
        swiperIndex.slideTo(indexPhoto, 0)
        setFullScreen(false)
    }

    return (
        <AppPermissionsSwitcher permission="AllowedPhotos" photos={slides} module={module}>
            {({ photos }) => (
                <>
                    <Swiper
                        pagination={{
                            type: 'fraction',
                        }}
                        modules={[Navigation, Pagination]}
                        navigation={true}
                        loop={false}
                        autoplay={false}
                        className="mySwiper swiper navigation-swiper"
                        onSwiper={setSwiperIndex}
                    >
                        <div className="swiper-wrapper">
                            {photos.map((photo, index) => {
                                return photo.isLoading ? (
                                    <SwiperSlide className={`${styles.slide}`} key={photo.id + '-' + index}>
                                        <Loader />
                                    </SwiperSlide>
                                ) : (
                                    <SwiperSlide className={`${styles.slide}`} key={photo.id + '-' + index}>
                                        <div className="position-absolute" style={{ top: '10px', right: '10px' }}>
                                            <Button onClick={() => handleLightBoxOpen(index)} color="primary" className="btn-icon">
                                                <i className="mdi mdi-fullscreen fs-17" />{' '}
                                            </Button>
                                        </div>
                                        <img className={`${styles.imgCover}`} src={photo.thumb} alt="" />
                                    </SwiperSlide>
                                )
                            })}
                        </div>
                    </Swiper>

                    {fullScreen && (
                        <LightboxGallery
                            imageList={photos}
                            indexPhoto={indexPhoto}
                            isOpen={fullScreen}
                            onClose={handleLightBoxClose}
                            setIndexPhoto={setIndexPhoto}
                        />
                    )}
                </>
            )}
        </AppPermissionsSwitcher>
    )
}

export default Slider

const LightboxGallery = ({ imageList, indexPhoto, isOpen, onClose, setIndexPhoto }) => {
    const originalUrlQueries = images.GetImagesByUrl.useQueries(imageList, 'original')
    const blobUrls = useBlobUrls(originalUrlQueries)

    const slides = imageList.map((file, i) => ({
        src: blobUrls[i],
    }))

    return (
        <Lightbox
            index={indexPhoto}
            open={isOpen}
            close={onClose}
            slides={slides}
            on={{ view: ({ index: currentIndex }) => setIndexPhoto(currentIndex) }}
            plugins={[Counter]}
            carousel={{ finite: true }}
        />
    )
}
